import { motion } from "framer-motion";

const CRAFT_IMG =
  "https://images.unsplash.com/photo-1575202332411-b01fe9ace7a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBoYW5kYmFnJTIwamV3ZWxyeXxlbnwwfHx8fDE3ODExMDk0NTl8MA&ixlib=rb-4.1.0&q=85";

const STATS = [
  { value: "142", label: "Hours per piece" },
  { value: "07", label: "Master ateliers" },
  { value: "< 50", label: "Pieces per edit" },
  { value: "100%", label: "Hand-finished" },
];

export default function Craftsmanship() {
  return (
    <section
      id="craftsmanship"
      data-testid="craftsmanship-section"
      className="relative bg-midnight py-24 md:py-36 px-6 md:px-12 lg:px-24"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-stretch">
        {/* Text */}
        <div className="md:col-span-6 flex flex-col justify-center order-2 md:order-1">
          <div className="eyebrow mb-6">Craftsmanship</div>
          <motion.h2
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif text-white text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight"
          >
            The slow art
            <br />
            of <span className="italic text-denim-light">making</span>.
          </motion.h2>
          <p className="mt-8 text-white/65 text-base md:text-lg font-light leading-relaxed max-w-lg">
            Selvedge denim from Okayama. Calfskin from Tuscany. Sterling
            from a single forge in Florence. Every Asymmetry piece is
            assembled by hand — patiently, deliberately, irreversibly.
          </p>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-2 gap-y-10 gap-x-8 max-w-md">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`craft-stat-${i}`}
              >
                <div className="font-serif text-white text-4xl md:text-5xl">
                  {s.value}
                </div>
                <div className="text-[10px] tracking-[0.32em] uppercase text-silver/70 mt-2">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Image */}
        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-6 order-1 md:order-2 relative aspect-[4/5] md:aspect-auto md:min-h-[640px] overflow-hidden border border-white/8"
        >
          <img
            src={CRAFT_IMG}
            alt="Hand-finished craftsmanship"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0b10] via-transparent to-transparent opacity-80" />
          <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-[10px] tracking-[0.32em] uppercase">
            <span className="text-silver">Atelier · Milano</span>
            <span className="text-white/70">N° 014 / 042</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
